import React from 'react';

const IcArrowFillRoundRightBlue = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_1_2588)'>
                <path d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z' fill='#264C97' />
                <path
                    d='M11.4318 5.30011C11.7853 5.01179 12.3074 5.03213 12.6369 5.36163L17.1369 9.86163C17.4882 10.2131 17.4882 10.7836 17.1369 11.1351C16.7854 11.4865 16.2149 11.4865 15.8634 11.1351L12.9005 8.17218V18.0013C12.9005 18.4983 12.4971 18.9016 12.0001 18.9017C11.5031 18.9017 11.0998 18.4983 11.0998 18.0013V8.17218L8.13686 11.1351C7.78541 11.4865 7.2149 11.4865 6.86342 11.1351C6.51195 10.7836 6.51195 10.2131 6.86342 9.86163L11.3634 5.36163L11.4318 5.30011Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_1_2588'>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IcArrowFillRoundRightBlue;
